import { Controller } from "@hotwired/stimulus"
// #AI: jQuery is loaded via Sprockets as a global variable
const $ = window.jQuery || window.$;

export default class extends Controller {
  static targets = [ "identifier" ]

  connect() {
    let identifier = `#${this.identifierTarget.id}`;
    $(identifier).multipleSelect({
      allSelected: true,
      formatAllSelected: () => $(identifier).data('all-options-selector-message'),
      formatSelectAll: () => $(identifier).data('toggle-selector-message'),
      filter: $(identifier).data('keyword-filter'),
      maxHeight: '400'
    });
  }
}
